// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import App from "./App"
import router from "./router"
import i18n from "./locale/index"
import store from "./store"

Vue.config.productionTip = false

import Vant, { Locale, Toast } from "vant"
import enUS from "vant/es/locale/lang/en-US"
import "vant/lib/index.css"
Locale.use("en-US", enUS)
Toast.setDefaultOptions("fail", { duration: 3000 })
Vue.use(Vant, Toast)

import ElementUI from "element-ui"
import locale from "element-ui/lib/locale/lang/en"
import "element-ui/lib/theme-chalk/index.css"
Vue.use(ElementUI, { size: "small", locale, zIndex: 5000 })

const originalNotify = ElementUI.Notification
Vue.prototype.$notify = (options = {}) => {
  const defaultOptions = { duration: 3000, showClose: true, type: "warning", position: "bottom-right" }
  if (typeof options === "string") options = { title: options }
  const mergedOptions = { ...defaultOptions, ...options }
  return originalNotify(mergedOptions)
}

Vue.prototype.$ELEMENT = {
  ...Vue.prototype.$ELEMENT,
  Notification: Vue.prototype.$notify
}

import * as echarts from "echarts"
Vue.prototype.$echarts = echarts

import "@/styles/index.css"
import "@/assets/fonts/iconfont.js"
import "@/assets/fonts/iconfont.css"
import IconFont from "@/assets/fonts/IconFont.vue"
Vue.component("IconFont", IconFont)

import dayjs from "dayjs"
Vue.prototype.$dayjs = dayjs

import { debounce } from "lodash"
Vue.prototype.$debounce = debounce

import * as filters from "./utils/filters"
Vue.prototype.$$ = filters.optionalChaining
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import SelfExplanation from "./components/commons/SelfExplanation/index"
Vue.use(SelfExplanation) // 注册自解释组件对话框

import SEBar from "@/components/commons/SelfExplanation/SEBar.vue"
Vue.component("SEBar", SEBar) // 注册自解释组件

const updateWindowSize = debounce(() => {
  store.dispatch("app/initWindowListener")
}, 200)
window.addEventListener("resize", updateWindowSize)
window.addEventListener("orientationchange", updateWindowSize)

const updateNetworkStatus = () => {
  store.commit("app/SET_NETWORK_STATUS", navigator.onLine)
}
updateNetworkStatus()
window.addEventListener("online", updateNetworkStatus)
window.addEventListener("offline", updateNetworkStatus)

new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: { App },
  template: "<App/>"
})



// WEBPACK FOOTER //
// ./src/main.js